import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { grey } from "@material-ui/core/colors";
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio'

export const GreyCheckbox = withStyles({
  root: {
    color: '#fff',
    '&$checked': {
      color: grey[100],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export const GreyRadio = withStyles({
  root: {
    color: '#fff',
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

